import React from "react";
import { Route, Switch } from "react-router-dom";
import Summary from "./Summary";
import List from "./List";
import BomUpload from "./Upload";
import Documents from "./Documents";
import History from "./History";
import Transactions from "./Transactions";
function Boms({ match }) {
  const { path } = match;

  return (
    <Switch>
      <Route exact path={path} component={List} />
      <Route path={`${path}/upload`} component={BomUpload} />
      <Route path={`${path}/:id/summary`} component={Summary} />
      <Route path={`${path}/:id/documents`} component={Documents} />
      <Route path={`${path}/:id/history`} component={History} />
      <Route path={`${path}/:id/transactions`} component={Transactions} />
    </Switch>
  );
}

export { Boms };
